import { Component } from '@angular/core';
import { UserService } from './service/userservice';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
 

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss'
})
export class UserManagementComponent {
    userName!: string;
 
  getUser: any;
  sno!: number;
  userIndex!: number;
  show = false;
  showNewUser = false;
  showUserDetail = false;
  checkComp = '';
  findRole!: number;
  showSelectParent = false;
  getUserObject: any;
  spinner = false;
  getUserName!: string;
  sampleRestul: any;
  getUserId!: number;
  getUserId2!: number;
  spinnerSent: boolean = true;
  myOptions = {};
  myOptions2 = {};
  resetPasswordForm!: boolean;
  getValue!: string;
  showInput: boolean = false;
  selectedSortOption!: string;
  sortedBy = ['Sort by recent', 'Sort by name'];
  searchText!: string;
  userId!: string;
  userId2!: any;
  userId_temp: any;
  userSubscription:any;
  userDetails: any;
   searchFilter:any=[];
 pageNo:number=0;
  userListData:any[]=[];
  currentUserDetail:any;
    constructor(private userService:UserService,private router:Router){

    }

    ngOnInit(){
      this.getUserList();

      this.myOptions = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
    };

    this.selectedSortOption = this.sortedBy[0];
     this.userService.getCurrentUser().subscribe({
          next:(response:any)=>{
            this.currentUserDetail = response;
          },
          error:(errors:HttpErrorResponse)=>{}
        });
    }

    sortUserName(){

    }

    showSearchField(){
      this.showInput = !this.showInput;
    }

    getUserList(){
      const payload = {
        "filters":this.searchFilter,
      "page": this.pageNo,
      "per_page": 1000,
      "sort_by": "email",
      "sort_order": "desc"
      };
       this.userService.getUserList(payload).subscribe({
        next:(response:any)=>{
           this.userListData = response['data'];
           if(this.userListData.length > 0){
            this.getUserObject = this.userListData[0];
            this.getUserDetails(this.getUserObject);
           }
        },
        error:(errors:HttpErrorResponse)=>{}
       })
    }

    selectComp(compName:string){
      this.checkComp = compName;
    }


    getUserDetails(user:any){
      this.getUserObject=user;
      this.checkComp='userDetail';
      this.router.navigateByUrl("/main/contracts/userManagement/"+user['id']);
    }

    newRegisterCancel(){
      this.checkComp='userDetail';
    }

}
